import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import { ScrollContainerWithHiddenScrollbar } from 'builder/components/ScrollContainer'

export const Container = styled(ScrollContainerWithHiddenScrollbar)<{ $autoTailorJob?: boolean }>`
  flex: 1;
  width: 100%;

  ${({ $autoTailorJob }) => {
    return `
      ${Media.Tablet`
        padding: ${$autoTailorJob ? '0' : '0 0 32px'};
      `}
    `
  }}
`

export const ContentSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 36px;
  background-color: ${Colors.White};
  transition: all 200ms ease-in;
  padding-bottom: 84px;
  min-height: 100%;
  border-radius: 12px 12px 0 0;

  ${Media.Phone`
    padding: 0 0 102px;
  `};
`
